import { type BaseItem } from '../common.js';
import { type Kind } from './apiInstance.js';

export enum ApiInstanceFhirMethod {
  DELETE = 'DELETE',
  GET = 'GET',
  PATCH = 'PATCH',
  POST = 'POST',
  PUT = 'PUT',
}
export interface ApiInstanceFhirEndpoint extends BaseItem {
  resource: string;
  scope: string;
  name: string;
  description: string;
  apiInstanceKind: Kind;
  method: ApiInstanceFhirMethod;
  path: string;
  documentationLink: string;
  deleted: string | null;
}
